module.exports = __webpack_public_path__ + "img/Balloon.83368191.png";